'use strict';
import React from 'react';

/**
 * Defines spacing for a group of radio buttons.
 *
 * Usage:
 *
 * ```Javascript
 * <RadioGroup>
 *   <Radio>Value1</Radio>
 *   <Radio>Value2</Radio>
 * </RadioGroup>
 * ```
 *
 * @extends {React.Compponent}
 */
class RadioGroup extends React.Component {
  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    return (
      <div className="Radio">
        {this.props.children}
      </div>
    );
  }
}

RadioGroup.defaultProps = {
  stacked: false
};

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/inputs/radioGroup.jsx